/** @format */

import React, { useState, useEffect } from "react";

function ViewMore({ batchItems, onClose }) {
  // Move hooks to the top of the component to ensure they are called unconditionally
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Set loading to false after the initial render, assuming data is passed in
  useEffect(() => {
    console.log("batch items", batchItems);
    if (batchItems) {
      setLoading(false);
    } else {
      setError(new Error("No batch data found."));
      setLoading(false);
    }
  }, [batchItems]);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;
  if (!batchItems || batchItems.length === 0)
    return <p>No Batch items found.</p>;

  return (
    <div className="fixed top-0 left-0 h-full flex items-center justify-center bg-black bg-opacity-50 z-50 w-full ">
      <div className="bg-white p-5 w-[80%] h-[70%] rounded-xl  relative overflow-auto">
        <div className="mb-6">
          <p className="font-sans text-[32px] font-bold text-center">
            Batch Items
          </p>
          <div
            className="flex flex-col font-sans font-bold ml-6 mt-6 rounded-xl item overflow-y-auto"
            style={{ maxHeight: "50vh" }}
          >
            <table className="table-auto border-none w-[95%] ">
              <thead>
                <tr className="bg-white">
                  <th className="text-primary px-4 py-2">Item Batch ID</th>
                  <th className="text-primary px-4 py-2">Item Name</th>
                  <th className="text-primary px-4 py-2">Current Qty</th>
                  <th className="text-primary px-4 py-2">Manufacture Date</th>
                  <th className="text-primary px-4 py-2">Expiration Date</th>
                  <th className="text-primary px-4 py-2">Store</th>
                  <th className="text-primary px-4 py-2">Location</th>
                </tr>
              </thead>
              <tbody>
                {batchItems.batches.map((item, index) => (
                  <tr key={index} className="">
                    <td className="bg-white px-4 py-2 text-center">
                      {item.inventory_batch_id}
                    </td>
                    <td className="bg-white px-4 py-2 text-center">
                      {item.inventory_item_description}
                    </td>
                    <td className="bg-white px-4 py-2 text-center">
                      {item.current_qty}
                    </td>
                    <td className="bg-white px-4 py-2 text-center">
                      {item.manufacture_date}
                    </td>
                    <td className="bg-white px-4 py-2 text-center">
                      {item.expiration_date}
                    </td>
                    <td className="bg-white px-4 py-2 text-center">
                      {item.store_id}
                    </td>
                    <td className="bg-white px-4 py-2 text-center">
                      {item.location}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <button
            className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 justify-center border-none rounded-[22px] bg-clsDialog w-[30.359px] h-[28px]"
            onClick={onClose}
          >
            <span className="text-white font-bold text-xl">X</span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default ViewMore;
